export const translationHR = {
    
};